import * as React from "react";
import styled, { css } from "styled-components";
import { ControlLabel } from "components/bootstrap";
import { SECURITY_EVENT_STATUSES } from "security-app/hooks/api/securityEventsAPI.types";
import { Select } from "components/common";
export const statusesOptions = Object.entries(SECURITY_EVENT_STATUSES).map(([value, label]) => ({ label, value }));
const StyledSelect = styled(Select)(
  ({ $width }) => css`
    width: ${$width};
    cursor: pointer;
  `
);
const StyledControlLabel = styled(ControlLabel)`
  margin: 0;
`;
const SetStatusControl = ({
  disabled = false,
  onStatusChange,
  value,
  width = "180px",
  size = "normal",
  label = "Status"
}) => {
  const filteredStatuses = value !== "NEW" ? statusesOptions.filter((option) => option.value !== "NEW") : statusesOptions;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, label && /* @__PURE__ */ React.createElement(StyledControlLabel, null, label), /* @__PURE__ */ React.createElement(
    StyledSelect,
    {
      $width: width,
      options: filteredStatuses,
      value,
      clearable: false,
      disabled,
      onChange: onStatusChange,
      persistSelection: false,
      size
    }
  ));
};
export default SetStatusControl;
